import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=713b8b22&functional=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports